import axios from "axios";
import { API_BASE_URL } from "./apiConfig";

const getAuthHeaders = (token) => ({
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "Content-Type": "application/json",
});

// ========================================
// CREATE RAZORPAY ORDER
// ========================================

export const createPaymentOrder = async (
    items,
    addressId,
    token,
    gstInvoice = null,
    regionDetails = null
) => {
    const requestData = {
        items,
        address_id: addressId,

        ...(regionDetails
            ? {
                  region: {
                      country_code: regionDetails.countryCode,
                      country_name: regionDetails.country,
                      currency_code: regionDetails.code,
                      exchange_rate: regionDetails.rate,
                      exchange_rate_updated_at:
                          regionDetails.rateUpdatedAt,
                      exchange_rate_source:
                          "open.er-api.com",
                      base_currency: "EUR",
                      base_subtotal_inr:
                          '462.05',
                      display_subtotal_estimate:
                          regionDetails.displaySubtotal,
                  },
              }
            : {}),

        ...(gstInvoice
            ? {
                  gst_name: gstInvoice.business_name,
                  gst_number: gstInvoice.gst_number,
              }
            : {}),
    };

    // =====================================================
    // CONSOLE BEFORE API HIT
    // =====================================================

    console.log("========================================");
    console.log("CREATE PAYMENT ORDER - API REQUEST");
    console.log("========================================");

    console.log("Items:", items);
    console.log("Address ID:", addressId);
    console.log("GST Invoice:", gstInvoice);
    console.log("Region Details:", regionDetails);
    console.log("Token exists:", !!token);

    console.log("Final Request Data:", requestData);

    console.log(
        "Final Request JSON:",
        JSON.stringify(requestData, null, 2)
    );

    console.log(
        "API URL:",
        `${API_BASE_URL}payments/create-order`
    );

    console.log("========================================");

    // =====================================================
    // API HIT
    // =====================================================

    const response = await axios.post(
        `${API_BASE_URL}payments/create-order`,
        requestData,
        {
            headers: getAuthHeaders(token),
        }
    );

    // =====================================================
    // API RESPONSE
    // =====================================================

    console.log("========================================");
    console.log("CREATE PAYMENT ORDER - API RESPONSE");
    console.log("========================================");

    console.log("Response:", response.data);

    console.log("========================================");

    return response.data;
};


// ========================================
// VERIFY RAZORPAY PAYMENT
// ========================================

export const verifyPayment = async (
    paymentData,
    token
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/verify`,
        paymentData,
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// GET ALL USER ORDERS
// ========================================

export const getMyOrders = async (
    token,
    params = {}
) => {
    const response = await axios.get(
        `${API_BASE_URL}payments/orders`,
        {
            headers: getAuthHeaders(token),
            params,
        }
    );

    return response.data;
};


// ========================================
// GET SINGLE ORDER
// ========================================

export const getOrderDetails = async (
    orderId,
    token
) => {
    const response = await axios.get(
        `${API_BASE_URL}payments/order/${orderId}`,
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// CANCEL PAYMENT
// ========================================

export const cancelPayment = async (
    orderId,
    token
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/cancel/${orderId}`,
        {},
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};


// ========================================
// FAILED PAYMENT
// ========================================

export const failPayment = async (
    orderId,
    token
) => {
    const response = await axios.post(
        `${API_BASE_URL}payments/failed/${orderId}`,
        {},
        {
            headers: getAuthHeaders(token),
        }
    );

    return response.data;
};